export const PRODUCT_TYPES = {
  FLASH: 'flash',
  TOP: 'top',
}

export const ALL_IN_ONE = {
  supertop: 'supertop',
  highlight: 'highlight',
  labelNew: 'new_label'
}

export const TIME_RANGE_VALUES = {
  day: 0,
  night: 1,
}

export const TIME_RANGES_VALUES = {
  NIGHT: gettext('Night'),
  MORNING: gettext('Morning'),
  AFTERNOON: gettext('Afternoon'),
  EVENING: gettext('Evening'),
}

export const TIME_SLOTS_LABELS = {
  NIGHT: gettext('All night'),
  MORNING: gettext('All morning'),
  AFTERNOON: gettext('All afternoon'),
  EVENING: gettext('All evening'),
}

export const TIME_RANGES_ORDER = ["MORNING", "AFTERNOON", "EVENING", "NIGHT"];

export function sortProductsByTimeStart(products) {
  return products.sort((a, b) => a.time_start24.localeCompare(b.time_start24));
}

export function sortTimeSlots(arr) {
  return arr.sort((a, b) => {
    // Check that not contains any digits
    const aIsWord = !/\d/.test(a);
    const bIsWord = !/\d/.test(b);

    // Make the string label first (EVENING, MORNING, AFTERNOON, NIGHT)
    if (aIsWord && !bIsWord) return -1;
    if (!aIsWord && bIsWord) return 1;

    // Sort by time (earliest first)
    if (!aIsWord && !bIsWord) {
      const aStartHour = parseInt(a.split(' - ')[0].split(':')[0]);
      const bStartHour = parseInt(b.split(' - ')[0].split(':')[0]);

      return aStartHour - bStartHour;
    }

    // Keep original order as default
    return 0;
  });
}

export function sortByValue(data) {
  if (!Array.isArray(data)) {
    throw new TypeError("Input must be an array.");
  }
  return [...data].sort((a, b) => a - b);
}

export function formatAddonTitle(type) {
  switch (type) {
    case "supertop":
      return "";
    case "highlight":
      return gettext("AddonHighlight");
    case "new_label":
      return gettext("AddonLabelNew");
    default:
      return "";
  }
} 